/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsProcessPayment
 */
export interface ControlcenterMelcoModelsProcessPayment {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsProcessPayment
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsProcessPayment
     */
    comments?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsProcessPayment
     */
    payment_status?: number;
}

export function ControlcenterMelcoModelsProcessPaymentFromJSON(json: any): ControlcenterMelcoModelsProcessPayment {
    return ControlcenterMelcoModelsProcessPaymentFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsProcessPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsProcessPayment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
        'payment_status': !exists(json, 'payment_status') ? undefined : json['payment_status'],
    };
}

export function ControlcenterMelcoModelsProcessPaymentToJSON(value?: ControlcenterMelcoModelsProcessPayment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_id': value.transaction_id,
        'comments': value.comments,
        'payment_status': value.payment_status,
    };
}


